module.exports = __webpack_public_path__ + "img/logo-white.7db7a3f4.svg";